import * as React from "react";

export default class Banner extends React.Component<{
    checked: boolean,
    children?: any,
    disabled?: boolean,
    onChange: (value: any) => void,
    style?: React.CSSProperties,
    value: any,
}, { hover: boolean }> {
    public constructor(props) {
        super(props);
        this.state = {
            hover: false,
        };
    }

    public render() {
        return <label
            className="CMS_radio CMS_radio_ml0"
            style={this.props.style}
        >
            <input
                type="radio"
                className="CMS_input"
                checked={this.props.checked}
                value={this.props.value}
                onChange={(e) => {
                    if (this.props.disabled) {
                        return;
                    }
                    this.props.onChange(this.props.value);
                }}
            />
            <span className={this.props.disabled ? "disabled" : ""}>
                <em className="fa" aria-hidden="true"></em>
            </span>
            {this.props.children}
        </label >;
    }
}
